import gql from 'graphql-tag'

export const generatePdfPrices = gql`
	mutation generatePdfPrices($dataJson: JSON!, $titles: JSON!) {
		cashAssist {
			generatePdfPrices(dataJson: $dataJson, titles: $titles) {
				url
			}
		}
	}
`

export const generatePDFAllSpecialOffers = gql`
	mutation generatePDFAllSpecialOffers($attributes: ProductSpecialOfferAttr!) {
		cashAssist {
			generatePDFAllSpecialOffers(attributes: $attributes){
				url
			}
		}
	}
`
